import { render, staticRenderFns } from "./FreezeInspector.vue?vue&type=template&id=41f21fd3&scoped=true"
import script from "./FreezeInspector.vue?vue&type=script&lang=js"
export * from "./FreezeInspector.vue?vue&type=script&lang=js"
import style0 from "./FreezeInspector.vue?vue&type=style&index=0&id=41f21fd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f21fd3",
  null
  
)

export default component.exports